import React, { Component } from 'react';
import { Route, Switch, Link } from 'react-router-dom';

import { apis, fetchData } from '../../../lib/apis';

import {
    ItemTag, PopupManageTags, WidgetFormEditQuickReply, FormReplyFast, SourceContact, FormNewDirect, LoadSpinner, MessageViewItem, FormReplyProduct,
    WidgetConfirmSales,
    WidgetPolicyTagFb
} from '../../../widgets';

import { send_mes } from '../../../lib/service';
import config, { TagsMessageFb } from '../../../lib/config';
import { Tooltip, Spin, Modal, Button, Input, Form, message, Popover, Carousel, Select, Switch as AntSwitch } from 'antd';
import qs from 'qs';
import Picker, { SKIN_TONE_MEDIUM_DARK } from "emoji-picker-react";

import ButtonShowEmoji from './elements/btn-emoji';

import WidgetListTag from "./elements/list-tag";

import WidgetFormSmsBrandName from "./elements/sms-brandname";

import cx from "classnames";
import { SearchOutlined, ExclamationCircleOutlined, ReloadOutlined, PlusOutlined, InfoCircleFilled } from '@ant-design/icons';

// Import react-icons
import { HiOutlinePlus, HiMicrophone, HiOutlinePaperClip, HiOutlineLightningBolt, HiOutlinePhotograph, HiOutlineTag } from 'react-icons/hi';
import { VscSmiley } from 'react-icons/vsc';
import { RiSendPlaneFill } from 'react-icons/ri';
import { MdOutlineAttachment } from 'react-icons/md';
import { BsThreeDotsVertical } from 'react-icons/bs';

const stageMap = {
    'GREETING': { name: 'Chào hỏi', color: '#8c8c8c' },
    'DISCOVERY': { name: 'Tìm hiểu', color: '#1890ff' },
    'PRESENTATION': { name: 'Tư vấn', color: '#722ed1' },
    'NEGOTIATION': { name: 'Thương lượng', color: '#fa8c16' },
    'CLOSING': { name: 'Chốt đơn', color: '#52c41a' },
    'HANDOVER': { name: 'Bàn giao', color: '#eb2f96' },
    'FOLLOW_UP': { name: 'Chăm sóc', color: '#13c2c2' }
};

export default class MessageView extends Component {
    constructor(props) {
        super(props);
        this.handleCommentReply = this.handleCommentReply.bind(this);
        this.handleShowFormDirectNew = this.handleShowFormDirectNew.bind(this);
        this.selectReply = this.selectReply.bind(this);

        this.page = 1;
        this.limit = 18;
        this.getDataNavigator = true;
        this.scrollBt = false;
        this.aiModeRequestId = 0;

        this.state = {
            listHtmlMessage: [],
            listMessage: [],
            array_id: [],
            showLoading: false,
            contact: null,
            reload: false,
            message: '',
            send_media: false,
            comment_reply: null,
            selectedAccInfo: {},
            visibleFormNewDirect: false,
            toUserMes: null,
            linkInsta: '',
            activeQuickReply: 0,
            previewImage: null,
            lastTimeSendDirect: 0,
            lastTimeSendCmt: 0,
            lastTimeSendDirectNew: 0,
            showViewImage: false,
            itemReadUser: null,
            ai_mode: false,
            conversation_ai_mode: false,
            ai_available: false,
            ai_status_loading: false,
            ai_warning: '',
            showMobileActionSheet: false
        }
        this.myRef = React.createRef();
        this.textAreaRef = React.createRef();
        this.refInputLinkInsta = null;

        this.type_send = 'text';

        this.innerHeight = window.innerHeight;
        this.focusSendMessage = false;
    }
    componentWillMount() {
        if (this.props.deviceType == "iOS") {
            let _this = this;
            window.onscroll = function (e) {
                console.log(e);
                if (document.querySelector("#topic-caption-panel")) {
                    if (_this.focusSendMessage == false) {
                        document.querySelector("#topic-caption-panel").style.transition = "unset";
                        document.querySelector("#sendMessage").blur();
                        document.querySelector("#topic-caption-panel").style.top = '0px';
                        // document.querySelector("#topic-caption-panel").style.paddingTop = _this.props.statusBarHeight+'px';
                        document.querySelector('#messages-panel').style.paddingTop = '15px';
                    } else {
                        document.querySelector("#topic-caption-panel").style.transition = "all 0.15s ease-in-out";
                        document.querySelector("#topic-caption-panel").style.top = window.pageYOffset + 'px';
                        // document.querySelector("#topic-caption-panel").style.paddingTop = _this.props.statusBarHeight+'px';
                        document.querySelector('#messages-panel').style.paddingTop = window.pageYOffset + 'px';
                    }
                }
                if (_this.focusSendMessage == true) {
                    _this.focusSendMessage = false;
                }
            }
        }
    }
    componentDidMount() {

    }
    componentDidUpdate(prevProps, prevState) {

    }
    componentWillReceiveProps(nextProps) {
        const oldId = this.props.contactInfoSelected && this.props.contactInfoSelected.contact_id;
        const newId = nextProps.contactInfoSelected && nextProps.contactInfoSelected.contact_id;
        if (newId && oldId !== newId) {
            this.getAIMode(newId);
        }
    }
    getAIMode = async (contactId) => {
        const requestId = ++this.aiModeRequestId;
        try {
            const cid = contactId || (this.props.contactInfoSelected && this.props.contactInfoSelected.contact_id);
            if (!cid) return;
            this.setState({
                ai_mode: false,
                ai_available: false,
                ai_status_loading: true,
                ai_warning: ''
            });
            let res = await fetchData({
                url: `api/v1/chat/ai/mode?contact_id=${cid}`
            });
            if (requestId !== this.aiModeRequestId) return;
            if (res.code === 200) {
                this.setState({
                    ai_mode: res.ai_mode === true,
                    conversation_ai_mode: res.conversation_ai_mode === true,
                    ai_available: res.ai_available === true,
                    ai_warning: res.warning || '',
                    ai_status_loading: false
                });
            }
        } catch (err) {
            if (requestId !== this.aiModeRequestId) return;
            console.error('Failed to get AI mode:', err);
            this.setState({
                ai_mode: false,
                ai_available: false,
                ai_status_loading: false,
                ai_warning: 'Không thể kiểm tra cấu hình AI chung. AI đang được tạm khóa để tránh tự động phản hồi ngoài ý muốn.'
            });
        }
    }
    showAIConfigurationWarning = () => {
        Modal.warning({
            title: this.state.ai_status_loading ? 'Đang kiểm tra cấu hình AI' : 'AI chung chưa sẵn sàng',
            content: this.state.ai_status_loading
                ? 'Vui lòng chờ hệ thống kiểm tra cấu hình AI chung của công ty.'
                : (this.state.ai_warning || 'Hãy bật AI trong phần Cấu hình AI trước khi bật AI cho hội thoại.'),
            okText: 'Đã hiểu'
        });
    }
    toggleAIMode = async (checked) => {
        try {
            const cid = this.props.contactInfoSelected && this.props.contactInfoSelected.contact_id;
            if (!cid) return;

            if (checked && !this.state.ai_available) {
                this.showAIConfigurationWarning();
                return;
            }

            this.setState({ ai_mode: checked });
            let res = await fetchData({
                url: `api/v1/chat/ai/toggle`,
                method: 'post',
                data: {
                    contact_id: cid,
                    ai_mode: checked
                }
            });
            if (res.code === 200) {
                this.setState({
                    ai_mode: res.ai_mode === true,
                    conversation_ai_mode: res.conversation_ai_mode === true,
                    ai_available: res.ai_available !== false,
                    ai_warning: res.warning || ''
                });
                message.success(checked ? 'Đã bật AI cho khách hàng này' : 'Đã tắt AI cho khách hàng này');
            }
        } catch (err) {
            const warning = err?.err?.warning || err?.warning;
            if (warning) {
                this.setState({
                    ai_mode: false,
                    ai_available: false,
                    ai_warning: warning
                }, this.showAIConfigurationWarning);
            } else {
                message.error('Không thể cập nhật chế độ AI');
                this.setState({ ai_mode: !checked });
            }
        }
    }
    clearAIHistory = async () => {
        const cid = this.props.contactInfoSelected && this.props.contactInfoSelected.contact_id;
        if (!cid) {
            message.warning('Không tìm thấy ID khách hàng');
            return;
        }

        Modal.confirm({
            title: 'Đặt lại toàn bộ dữ liệu AI?',
            icon: <ExclamationCircleOutlined />,
            content: 'Việc này sẽ xóa sạch: Lịch sử hội thoại, Giai đoạn bán hàng, và các thông tin đã trích xuất. AI sẽ bắt đầu mới hoàn toàn.',
            okText: 'Xóa sạch',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    let res = await fetchData({
                        url: `api/v1/app/ai/history/clear`,
                        method: 'post',
                        data: {
                            contact_id: cid
                        }
                    });
                    if (res.code === 200) {
                        message.success('Đã xóa sạch bộ nhớ AI');
                        // Refresh data để cập nhật Stage/Lead info về mặc định
                        this.getAIMode(cid);
                    }
                } catch (err) {
                    message.error('Không thể xóa lịch sử AI');
                }
            }
        });
    }
    toggleMobileActionSheet = (visible) => {
        this.setState({ showMobileActionSheet: visible });
    }
    runMobileHeaderAction = (callback) => (e) => {
        if (e && e.preventDefault) e.preventDefault();
        this.setState({ showMobileActionSheet: false }, () => {
            if (callback) callback();
        });
    }
    openInfoPanel = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const { pathname, search } = this.props.history.location;
        this.setState({ showMobileActionSheet: false }, () => {
            this.props.history.replace(`${pathname}${search || ''}#info`);
        });
    }
    renderExtractedInfo = (info) => {
        if (!info || Object.keys(info).length === 0) return null;
        const items = [];
        if (info.phone) items.push(<span key="p" style={{ marginRight: '10px', color: '#1890ff' }}><i className="fas fa-phone-alt" style={{ fontSize: '10px' }}/> {info.phone}</span>);
        if (info.product) items.push(<span key="pr" style={{ marginRight: '10px', color: '#52c41a' }}><i className="fas fa-shopping-cart" style={{ fontSize: '10px' }}/> {info.product}</span>);
        
        if (items.length === 0) return null;
        return <div style={{ fontSize: '11px', display: 'flex', alignItems: 'center' }}>{items}</div>;
    }
    handleSend(e, tag) {
        e.preventDefault();
        if (this.props.contactInfoSelected.type == "comment" && !this.state.comment_reply) {
            this.props.showNotiFy('Không có bình luận để trả lời !');
            return;
        };

        const message = this.state.message ? this.state.message.trim() : "";
        var attachments = this.state.attachmentPreview || [];

        if (attachments.length > 0) {
            for (let i = 0; i < attachments.length; i++) {
                if (attachments[i]['code'] != 200) return;
            }
        }
        this.setState({
            message: '',
            attachmentPreview: null
        }, () => {
            if (this.textAreaRef.current) {
                this.textAreaRef.current.style.height = '24px';
            }
            if (message) {
                this.sendMessage({
                    content: message,
                    item_type: 'text',
                    message_tag: tag
                });
            }
            setTimeout(() => {
                attachments.forEach((attachment) => {
                    this.sendMessage({
                        attachment: attachment,
                        item_type: 'attachment',
                        message_tag: tag
                    });
                })
            }, 300)
        })
    }

    handleSendTag(e) {
        e.preventDefault();
        let _this = this;
        let tag = "HUMAN_AGENT";
        Modal.confirm({
            title: "Gửi tin nhắn đính kèm nhãn",
            width: 600,
            content: <>
                <Form
                    layout="vertical"
                    initialValues={{
                        tag: tag
                    }}
                >
                    <Form.Item
                        name="tag"
                        label={<span className="d-flex align-items-center"><InfoCircleFilled style={{ color: "#1a90ff", marginRight: "5px" }} onClick={() => _this.setState({ visiblePolicyTagFb: true })} /> Chọn tag</span>}
                    >
                        <Select
                            placeholder="Chọn tag"
                            optionFilterProp="children"
                            className="text-left"
                            onChange={(e) => {
                                tag = e
                            }}
                        >
                            {
                                TagsMessageFb.map((item) => {
                                    return <Select.Option value={item}>{item}</Select.Option>
                                })
                            }
                        </Select>
                    </Form.Item>
                </Form>
            </>,
            okText: 'Gửi tin nhắn ngay',
            cancelText: 'Hủy',
            onOk: () => {
                _this.handleSend(e, tag)
            },
            onCancel: () => {

            }
        })
    }

    async sendMessage(data_send) {
        let id = data_send.id || Date.now();
        data_send.id = id;
        const isZalo = this.props.channelSelected.acc_type == 0 || this.props.channelSelected.acc_type == 7;
        const isTelegram = this.props.channelSelected.acc_type == 11;
        const isWhatsApp = this.props.channelSelected.acc_type == 12 || this.props.contactInfoSelected.type == 'whatsapp';
        const isWebChat = this.props.channelSelected.acc_type == 10 || this.props.contactInfoSelected.type == 'webchat';
        const isDirectStyleChat = this.props.contactInfoSelected.type == 'direct' || isZalo || isTelegram || isWhatsApp || isWebChat;
        try {
            let { item_type, content, attachment, replay } = data_send;
            let comment_reply = this.state.comment_reply;

            if(data_send.content && data_send.content.length > 2000){
                throw({
                    message: "Tin nhắn không được vượt quá 2000 ký tự"
                })
            }

            data_send['contact_id'] = this.props.contactInfoSelected.contact_id;

            let url = this.props.contactInfoSelected.type == 'direct' ? 'api/v1/chat/fanpagefb/send' : 'api/v1/chat/fanpagefb/comment';
            let apiData = data_send;

            if (isZalo) {
                url = 'api/v1/zalo/send';
                apiData = {
                    channel_id: this.props.channelSelected._id,
                    recipient_id: this.props.contactInfoSelected.user_id,
                    message: content,
                    // thread_type: 'text' 
                };
            }

            if (isTelegram) {
                url = 'api/v1/telegram/send';
                apiData = {
                    channel_id: this.props.channelSelected._id,
                    to_user_id: this.props.contactInfoSelected.user_id,
                    text: content,
                    attachment: attachment ? {
                        url: attachment.url,
                        type: attachment.type
                    } : null
                };
            }

            if (isWebChat) {
                if (attachment) {
                    throw ({ message: 'Website chat hiện chưa hỗ trợ gửi tệp đính kèm từ CRM' });
                }

                url = 'api/v1/chat/webchat/send';
                apiData = {
                    session_id: this.props.contactInfoSelected.thread_id || this.props.contactInfoSelected.user_id,
                    channel_token: this.props.channelSelected.token,
                    message: content
                };
            }

            if (isWhatsApp) {
                url = 'api/v1/whatsapp/send';
                apiData = {
                    channel_id: this.props.channelSelected._id,
                    to_user_id: this.props.contactInfoSelected.user_id,
                    text: content,
                    attachment: attachment ? {
                        url: attachment.url,
                        type: attachment.type,
                        name: attachment.name,
                        caption: content || ''
                    } : null
                };
            }

            if (!replay) {
                let data_pending = {
                    _id: id,
                    contact_id: this.props.contactInfoSelected.contact_id,
                    user_id: this.props.channelSelected.user_id,
                    timestamp: Date.now() + 5000,
                    status_send: 1,
                    content: content,
                    item_type: item_type,
                    attachments: attachment ? [
                        {
                            type: attachment.type,
                            payload: { url: attachment.url }
                        }
                    ] : [],
                    data_send: data_send
                }

                if (isDirectStyleChat) {
                    this.props.listMessage.push(data_pending);
                    data_send['to_user_id'] = this.props.contactInfoSelected.user_id;
                    this.props.scrollToBottom();
                } else {
                    let find = this.props.listMessage.findIndex((item) => item.comment_id == (comment_reply.parent_id || comment_reply.comment_id));
                    if (find == -1) throw ({ message: 'Comment không hợp lệ' });

                    data_send['comment_id'] = comment_reply.comment_id;

                    this.props.listMessage[find]['reply'].push(data_pending);

                }
                this.props.reload();
            } else if (data_send.send_24h) {
                message.loading({
                    content: "Đang gửi tin nhắn sau 24h, bạn vui lòng chờ!",
                    duration: 0,
                    key: "send_24h"
                })
            }
            let response = null;

            try {
                response = await fetchData({
                    url: url,
                    method: 'post',
                    data: apiData
                })
            } catch (err) {
                data_send.replay = false;
                throw (err);
            } finally {
                message.destroy("send_24h");
            }

            if (data_send.send_24h) {
                let find = this.props.listMessage.findIndex((item) => item._id == id);
                if (find > -1) {
                    this.props.listMessage[find] = response.payload;
                }
                message.success({
                    content: "Gửi tin nhắn sau 24h thành công",
                    duration: 5
                })
            } else {
                if (isDirectStyleChat) {
                    let find = this.props.listMessage.findIndex((item) => item._id == id);
                    if (find > -1) {
                        if ((isZalo || isWebChat || isWhatsApp) && (!response || !response.payload)) {
                            this.props.listMessage[find].status_send = 2;
                        } else {
                            this.props.listMessage[find] = response.payload;
                        }
                    }
                } else {
                    let find = this.props.listMessage.findIndex((item) => item.comment_id == response.payload.parent_id);
                    if (find > -1) {
                        let find_reply = this.props.listMessage[find]['reply'].findIndex((item) => item._id == id);
                        if (find_reply > - 1) {
                            this.props.listMessage[find]['reply'].splice(find_reply, 1);
                        }
                        let find_comment = this.props.listMessage[find]['reply'].findIndex((item) => item.comment_id == response.payload.comment_id);
                        if (find_comment == -1) {
                            this.props.listMessage[find]['reply'].push(response.payload);
                        }
                    }
                }
            }
            this.props.reload();
        } catch (err) {
            let error = typeof err == "object" ? err.message : 'Không thể gửi tin nhắn vui lòng thử lại!';
            if (error.indexOf('#100') > -1 && !(typeof err == "object" && err.errors?.error_subcode == 2018276) && !data_send.replay) {
                await this.props.sleep(1000);
                data_send.replay = true;
                this.sendMessage(data_send);
            } else if (typeof err == "object" && err.errors && err.errors.error_subcode == 2018278 && !data_send.replay && !data_send.send_24h) {
                await this.props.sleep(1000);
                this.sendMessage({
                    ...data_send,
                    replay: true,
                    send_24h: true
                });
            } else {
                if (isDirectStyleChat) {
                    let find = this.props.listMessage.findIndex((item) => item._id == id);
                    if (find > -1) {
                        this.props.listMessage[find]['status_send'] = 3;
                        this.props.listMessage[find]['error_send'] = error;
                    }
                } else {
                    let find = this.props.listMessage.findIndex((item) => (item.reply || []).find((reply) => reply._id === id));
                    if (find > - 1) {
                        let find_reply = this.props.listMessage[find]['reply'].findIndex((item) => item._id == id);
                        if (find_reply > -1) {
                            this.props.listMessage[find]['reply'][find_reply]['status_send'] = 3;;
                            this.props.listMessage[find]['reply'][find_reply]['error_send'] = error;
                        }
                    }
                }
                this.props.reload();
                this.props.notification({
                    title: "Gửi tin nhắn",
                    content: error,
                    type: "error",
                    duration: 5
                })
            }
        }
    }
    sendDirect = async (data) => {
        try {
            this.setState({ loadingDirectNew: true });
            let response = await fetchData({
                url: `api/v1/chat/fanpagefb/send`,
                method: 'post',
                data: data
            })
            this.setState({
                visibleFormNewDirect: false,
                loadingDirectNew: false
            })
            this.props.notification({
                title: "Gửi tin nhắn",
                content: "Thao tác thành công",
                type: "success"
            })
        } catch (err) {
            this.setState({ loadingDirectNew: false });
            this.props.notification({
                title: "Gửi tin nhắn",
                content: err.message || "Không thể gửi tin nhắn vui lòng thử lại!",
                type: "error"
            })
        }
    }
    handleCommentReply = (comment_reply) => {
        this.setState({
            comment_reply: comment_reply,
            message: comment_reply.from.full_name + " "
        }, () => {
            if (!this.props.isMobile) this.textAreaRef.focus();
        })
    }
    handleShowFormDirectNew = async (bol = false, user = null) => {
        if (!bol) {
            this.setState({
                visibleFormNewDirect: false,
                toUserMes: null
            });
            return;
        }
        try {
            let res = await fetchData({
                url: 'api/v1/chat/direct/history/check',
                method: 'post',
                data: {
                    user_id: this.props.channelSelected.user_id,
                    to_user_id: user.user_id || user.userid
                }
            })
            let type_send = 'direct_new';
            if (res.data.contact) {
                type_send = 'direct';
            } else {
                let time_comp = new Date().getTime() - this.state.lastTimeSendDirectNew;
                let max_time = config.block_send.block_insta_direct_new - Math.floor(time_comp / 1000);
                if (!this.state.countDownDirectNew || this.state.countDownDirectNew <= 0 && max_time > 0) {
                    this.countDownIntervalDirectNew = setInterval(() => {
                        if (max_time >= 0) {
                            this.setState({
                                countDownDirectNew: max_time--
                            })
                        } else {
                            clearInterval(this.countDownIntervalDirectNew);
                        }
                    }, 1000);
                }
            }
            this.setState({
                visibleFormNewDirect: bol,
                toUserMes: {
                    comment: user,
                    type_send: type_send,
                    history: res.data.history ? res.data.history : [],
                    contact: res.data.contact
                }
            }, () => {
                setTimeout(() => {
                    let slt_history = document.querySelector('.history-direct');
                    if (slt_history) {
                        slt_history.scrollTop = slt_history.scrollHeight;
                    }
                }, 100);
            });
        } catch (err) {
            this.props.showNotiFy('Đã có lỗi xảy ra !');
        }
    }
    handleKeyUp = (e) => {
        if (this.state.showReplyProduct) {
            let quickReply = this.state.quickReply;
            let activeQuickReply = this.state.activeQuickReply;
            if (e.key == 'ArrowUp') {
                activeQuickReply -= 1;
                activeQuickReply = activeQuickReply >= 0 ? activeQuickReply : quickReply.length - 1;
                this.setState({
                    activeQuickReply: activeQuickReply
                })
            } else if (e.key == 'ArrowDown') {
                activeQuickReply += 1;
                activeQuickReply = activeQuickReply > quickReply.length - 1 ? 0 : activeQuickReply;
                this.setState({
                    activeQuickReply: activeQuickReply
                })
            } else if (e.key == 'Enter') {
                let message = quickReply[activeQuickReply] ? quickReply[activeQuickReply]['message'].toString() : '';
                this.setState({
                    message: this.decodeMess(message),
                    showReplyProduct: false
                });
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        } else {
            if (e.key === 'Enter') {
                if (!e.shiftKey && !this.props.isMobile) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.handleSend(e);
                }
            }
        }
    }
    decodeMess = (message = '') => {
        try {
            let obj_user = this.props.contactInfoSelected.from;
            let matching = message.match(/#{(.*?)?}/gm);
            if (matching) {
                matching.forEach((match) => {
                    let arr_match = match.split('|');
                    let match_u = arr_match[Math.floor(Math.random() * arr_match.length)].trim('').replace(/[\#|\{|\}]/g, '');
                    let mes_data = obj_user[match_u] ? obj_user[match_u] : match_u;
                    message = message.replace(match, mes_data);
                })
            }
            return message;
        } catch (err) {
            return "";
        }
    }
    changeMessage = (e) => {
        if (this.state.message[0] == '/') {
            if (!this.props.settingSystem.quick_reply || this.props.settingSystem.quick_reply.length === 0) {
                this.setState({
                    showFormQuickRepy: true
                })
                return false;
            }
            let filter = this.state.message.length > 2 ? this.state.message.slice(1) : '';
            let quick_reply = [];
            this.props.settingSystem.quick_reply.forEach((item, i) => {
                if (item.short_cut.indexOf(filter) != -1) {
                    quick_reply.push(item);
                }
            })
            this.setState({
                quickReply: quick_reply,
                showReplyFast: true
            })
        } else {
            this.setState({
                showReplyFast: false
            })
        }
    }
    selectReply = (options = {}) => {
        let { content, attachments } = options;
        if (attachments) {
            attachments = attachments.map((attachment) => { attachment.code = 200; return attachment }) || [];
        }
        let matching = content.match(/#{(.*?)?}/gm);
        if (matching) {
            matching.forEach((match) => {
                content = this.decodeMess(content, match);
            })
        }
        this.setState({
            showReplyProduct: false,
            activeQuickReply: 0,
            message: content,
            attachmentPreview: attachments,
            showReplyFast: false
        }, () => {
            if (!this.props.isMobile) this.textAreaRef.focus();
        })
    }
    previewImage = (file) => {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.onload = function (e) {
                return resolve(e.target.result);
            }
            reader.readAsDataURL(file);
        })
    }
    uploadImage = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        let _this = this;
        if (e.target.files.length > 0) {
            try {
                let promise = []
                for (const file of e.target.files) {
                    promise.push(new Promise(async (resolve, reject) => {
                        try {
                            let url = URL.createObjectURL(file);
                            let attachmentPreview = {
                                type: file.type,
                                url: url,
                                name: file.name
                            }

                            // console.log(attachmentPreview);
                            let formData = new FormData();
                            formData.append('attachment', file);
                            console.log('start---------');
                            let res_upload = await fetchData({
                                url: `api/v1/chat/fanpagefb/${_this.props.channelSelected.user_id}/upload_attactment`,
                                data: formData,
                                method: 'post',
                                type_post: 'upload_image'
                            });
                            attachmentPreview['type'] = res_upload.attachment.type;
                            attachmentPreview['code'] = 200;
                            attachmentPreview['url'] = `${process.env.REACT_APP_API_CHOTSALE_URL}/api/v1/${res_upload.attachment.url}`;

                            URL.revokeObjectURL(file);

                            return resolve(attachmentPreview)

                        } catch (err) {
                            reject(err)
                        }
                    }))
                }
                e.target.value = "";

                if (!this.props.isMobile) this.textAreaRef.focus();
                let results = await Promise.all(promise)

                _this.setState({
                    attachmentPreview: results
                })
            } catch (err) {
                console.error(err)
                message.warning({ content: 'Upload không thành công!', key: 'error_api' });
            }
        }

    }
    showViewImage = (link = '') => {
        this.setState({
            linkViewImage: link,
            showViewImage: true
        })
    }
    replaySendMessage = (data) => {
        try {
            let { id, data_send, type } = data;
            let replay = false;
            if (this.props.contactInfoSelected.type == 'direct' || this.props.contactInfoSelected.type == 'whatsapp') {
                let find = this.props.listMessage.findIndex((item) => item._id == id);
                if (find > -1) {
                    this.props.listMessage[find]['status_send'] = 1;
                    replay = true;
                }
            } else {
                let find = this.props.listMessage.findIndex((item) => (item.reply || []).find((reply) => reply._id === id));
                if (find > - 1) {
                    let find_reply = this.props.listMessage[find]['reply'].findIndex((item) => item._id == id);
                    if (find_reply > -1) {
                        this.props.listMessage[find]['reply'][find_reply]['status_send'] = 1;
                        replay = true;
                    }
                }
            }
            data_send.replay = replay;
            if (replay) {
                this.setState({
                    reload: !this.state.reload
                }, () => {
                    this.sendMessage(data_send);
                })
            }
        } catch (err) {

        }
    }
    render() {
        let link = '';
        let inputUploadAttachment = '';
        let topTitle = '';
        let btnUpload = <Tooltip placement="top" title={'Tệp đính kèm'} mouseEnterDelay={this.props.mouseEnterDelayTooltip} mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}>
            <label
                style={{ color: 'rgb(0, 102, 255)', display: 'flex', marginRight: '5px' }}
                className="btn-manage-tool"
                htmlFor="inputUploadImage"
            >
                <i className="far fa-paperclip"></i>
            </label>
        </Tooltip>;
        let link_picture = '/user.jpg';

        if (this.props.contactInfoSelected) {
            if (this.props.channelSelected.acc_type == 1) link = `https://www.instagram.com/${this.props.contactInfoSelected.username}`;
            if (this.props.channelSelected.acc_type == 5) {
                // if (this.props.contactInfoSelected.type == 'comment' && this.props.listMessage.length > 0) {
                //     link = `https://facebook.com/${this.props.listMessage[this.props.listMessage.length - 1]['comment_id']}`
                // }
                // if (this.props.contactInfoSelected.type == 'direct') {
                //     link = this.props.contactInfoSelected.from.user_id2 ? `https://facebook.com/${this.props.contactInfoSelected.from.user_id2}` : "#"
                // }
                link = this.props.contactInfoSelected.from.user_id2 ? `https://facebook.com/${this.props.contactInfoSelected.from.user_id2}` : "#"
            }
            if (this.props.channelSelected.acc_type == 1) {
                topTitle = <a target="_blank" href={`https://www.instagram.com/${this.props.contactInfoSelected.username}`} id="topic-title" className="panel-title">{this.props.contactInfoSelected.username}</a>
            } else {
                topTitle = <a href="#" onClick={(e) => e.preventDefault()} id="topic-title" className="panel-title">{this.props.contactInfoSelected.thread_title} <span style={{ color: "#666666", fontWeight: "500" }}>{this.props.channelSelected.alias ? `( ${this.props.channelSelected.alias} )` : ''}</span></a>
            }

            let type_send = this.props.contactInfoSelected.type;
            if (this.props.channelSelected.acc_type == 5) {
                inputUploadAttachment = type_send == 'direct' ? <input type="file" style={{ display: 'none' }} id="inputUploadImage"
                    onChange={this.uploadImage}
                    multiple
                /> : <input type="file" accept="image/jpg, image/jpeg, image/png" style={{ display: 'none' }} id="inputUploadImage"
                    onChange={this.uploadImage}
                    multiple
                />
            } else if (this.props.channelSelected.acc_type == 1 && type_send == 'direct') {
                inputUploadAttachment = <input type="file" accept="image/jpg, image/jpeg, image/png" style={{ display: 'none' }} id="inputUploadImage"
                    onChange={this.uploadImage}
                    multiple
                />;
            } else {
                btnUpload = '';
            }
            link_picture = this.props.contactInfoSelected.avatar || (this.props.contactInfoSelected.from && this.props.contactInfoSelected.from.avatar) || this.props.contactInfoSelected.picture || '/user.jpg';
        }
        var avatar = <img className="avatar"
            src={link_picture}
            onLoad={(e) => {
                e.target.className = "avatar avatar-ready";
            }}
            onError={(e) => {
                e.target.src = "/user.jpg"
            }}
        />

        let htmlPreviewAttachment = [];
        if (this.state.attachmentPreview) {
            let attachments = this.state.attachmentPreview;
            attachments.forEach((attachment, i) => {
                if (attachment.type.indexOf('image') > -1) {
                    htmlPreviewAttachment.push(<div className={attachment.code == 200 ? "preview-image image-upload success" : "preview-image image-upload"}>
                        <img src={attachment.url} className="" onClick={() => {
                            window.open(attachment.url);
                        }} />
                        <i className="material-icons close" onClick={(e) => {
                            e.preventDefault();
                            this.state.attachmentPreview.splice(i, 1);
                            this.setState({ reload: !this.state.reload });
                        }}>close</i>
                    </div>)
                } else {
                    htmlPreviewAttachment.push(<div className={attachment.code == 200 ? "preview-image image-upload success" : "preview-image image-upload"}>
                        <div className="file" onClick={() => {
                            window.open(attachment.url);
                        }}>
                            <i className="fal fa-file-alt"></i>
                            <div className="file-name">{attachment.type || attachment.name}</div>
                        </div>
                        <i className="material-icons close" onClick={(e) => {
                            e.preventDefault();
                            this.state.attachmentPreview.splice(i, 1);
                            this.setState({ reload: !this.state.reload });
                        }}>close</i>
                    </div>)
                }
            })
        }
        let tag_favourites = [];
        if (this.props.settingSystem) {
            tag_favourites = this.props.settingSystem.tags.filter((item) => item.is_favourite);
        }
        const uidFilter = this.props.contactInfoSelected ? `uid:${this.props.contactInfoSelected.user_id || this.props.contactInfoSelected.userid}` : '';
        const postFilter = this.props.contactInfoSelected ? `post:${this.props.contactInfoSelected.media_id}` : '';
        const canShowHistoryContact = this.props.UserLogin.role_action.indexOf('full_role') > -1 || this.props.UserLogin.role_action.indexOf('history_contact_sale') > -1;
        const canChangeSales = this.props.contactInfoSelected && (this.props.contactInfoSelected.sale && this.props.contactInfoSelected.sale.status == 1 || (this.props.UserLogin.role_company.indexOf('sale') == -1 && this.props.contactInfoSelected.sales && this.props.contactInfoSelected.sales.length == 0));
        const canFilterPostConversation = this.props.contactInfoSelected && this.props.contactInfoSelected.type == 'comment';
        const canViewFacebook = this.props.contactInfoSelected && (this.props.contactInfoSelected.type == "direct" || this.props.contactInfoSelected.type == "comment") && this.props.isSalesContact && link != "#";
        const canCallCustomer = this.props.contactInfoSelected && (this.props.contactInfoSelected.type == "callcenter" || this.props.contactInfoSelected.type == "www")
            && (this.props.isSalesContact || this.props.contactInfoSelected.num_care == 0);
        const canToggleHiddenComment = this.props.contactInfoSelected && this.props.contactInfoSelected.type == 'comment';
        const mobileHeaderActions = [];

        if (this.props.contactInfoSelected) {
            mobileHeaderActions.push({
                key: 'info',
                label: 'Thông tin khách hàng',
                description: 'Xem hồ sơ, tag và ghi chú của khách.',
                icon: <i className="far fa-info-circle"></i>,
                onClick: this.openInfoPanel
            });
            const aiUnavailable = !this.state.ai_available;
            mobileHeaderActions.push({
                key: 'ai-toggle',
                label: this.state.ai_status_loading ? 'Đang kiểm tra AI' : (aiUnavailable ? 'AI chưa sẵn sàng' : (this.state.ai_mode ? 'Tắt AI' : 'Bật AI')),
                description: aiUnavailable
                    ? (this.state.ai_status_loading ? 'Đang tải cấu hình AI chung của công ty.' : (this.state.ai_warning || 'AI chung của công ty chưa được bật.'))
                    : (this.state.ai_mode ? 'AI đang phản hồi cho hội thoại này.' : 'Bật AI để hỗ trợ tư vấn tự động.'),
                icon: aiUnavailable ? <ExclamationCircleOutlined style={{ color: '#fa8c16' }} /> : <i className="fas fa-robot"></i>,
                suffix: aiUnavailable
                    ? <span style={{ color: '#fa8c16', fontSize: '11px', fontWeight: 600 }}>Cần cấu hình</span>
                    : <AntSwitch size="small" checked={this.state.ai_mode} style={{ pointerEvents: 'none' }} />,
                onClick: this.runMobileHeaderAction(aiUnavailable
                    ? this.showAIConfigurationWarning
                    : () => this.toggleAIMode(!this.state.ai_mode))
            });
            mobileHeaderActions.push({
                key: 'ai-reset',
                label: 'Reset AI',
                description: 'Xóa bộ nhớ AI và khởi tạo lại cuộc hội thoại.',
                icon: <ReloadOutlined />,
                dangerous: true,
                onClick: this.runMobileHeaderAction(this.clearAIHistory)
            });

            if (canShowHistoryContact) {
                mobileHeaderActions.push({
                    key: 'care-history',
                    label: 'Lịch sử chăm sóc',
                    description: 'Xem lịch sử chăm sóc khách hàng.',
                    icon: <i className="far fa-history"></i>,
                    onClick: this.runMobileHeaderAction(() => this.props.handleHistoryContactSale())
                });
            }

            if (canChangeSales) {
                mobileHeaderActions.push({
                    key: 'change-sales',
                    label: 'Chuyển nhân viên',
                    description: 'Bàn giao hoặc đổi nhân viên phụ trách khách này.',
                    icon: <i className="far fa-user-cog"></i>,
                    onClick: this.runMobileHeaderAction(() => {
                        if (!(this.props.contactInfoSelected && this.props.contactInfoSelected.sale && this.props.contactInfoSelected.sale.status == 3)) {
                            this.props.handleModalChangeSales();
                        }
                    })
                });
            }

            if (canFilterPostConversation) {
                mobileHeaderActions.push({
                    key: 'post-conversations',
                    label: 'Hội thoại bài viết',
                    description: 'Lọc toàn bộ bình luận của bài viết này.',
                    icon: <i className="far fa-comments-alt"></i>,
                    active: this.props.search_keyword === postFilter,
                    onClick: this.runMobileHeaderAction(() => this.props.handleSearchKeyword(postFilter))
                });
            }

            mobileHeaderActions.push({
                key: 'user-conversations',
                label: 'Hội thoại khách hàng',
                description: 'Xem tất cả cuộc trò chuyện của khách này.',
                icon: <i className="far fa-user-circle"></i>,
                active: this.props.search_keyword === uidFilter,
                onClick: this.runMobileHeaderAction(() => this.props.handleSearchKeyword(uidFilter))
            });

            if (canViewFacebook) {
                mobileHeaderActions.push({
                    key: 'open-facebook',
                    label: 'Mở trên Facebook',
                    description: 'Đi tới hội thoại gốc trên Facebook.',
                    icon: <i className="fab fa-facebook-f"></i>,
                    onClick: this.runMobileHeaderAction(() => window.open(link, '_blank'))
                });
            }

            if (canCallCustomer) {
                mobileHeaderActions.push({
                    key: 'call-customer',
                    label: 'Gọi khách hàng',
                    description: 'Thực hiện cuộc gọi trực tiếp từ CRM.',
                    icon: <i className="far fa-phone"></i>,
                    onClick: this.runMobileHeaderAction(() => this.props.handleCallCustomer({
                        cus_phone: this.props.contactInfoSelected.num_care == 0 ? null : this.props.contactInfoSelected.user_id,
                        contact_id: this.props.contactInfoSelected.contact_id
                    }))
                });
            }

            if (canToggleHiddenComment) {
                mobileHeaderActions.push({
                    key: 'toggle-hidden-comment',
                    label: this.state.hiddenComment ? 'Bật hiển thị bình luận' : 'Ẩn bình luận',
                    description: 'Điều chỉnh trạng thái ẩn hiện của bình luận trên Facebook.',
                    icon: this.state.hiddenComment ? <i className="fa fa-eye-slash"></i> : <i className="fa fa-eye"></i>,
                    onClick: this.runMobileHeaderAction(this.hiddenComment)
                });
            }
        }

        // console.log(this.props.contactInfoSelected, this.props.settingSystem);
        return (
            <div id="topic-view" >
                <WidgetPolicyTagFb
                    visible={this.state.visiblePolicyTagFb}
                    hide={() => this.setState({ visiblePolicyTagFb: false })}
                />
                <FormNewDirect visible={this.state.visibleFormNewDirect} contactInfoSelected={this.props.contactInfoSelected}
                    hide={() => this.setState({ visibleFormNewDirect: false })}
                    loadingDirectNew={this.state.loadingDirectNew}
                    sendDirect={this.sendDirect}
                    toUserMes={this.state.toUserMes}
                    channelSelected={this.props.channelSelected}
                    handleDetailUser={this.props.handleDetailUser}
                />
                <FormReplyProduct {...this.props} visible={this.state.showReplyProduct}
                    hide={() => this.setState({ showReplyProduct: false })} selectReply={this.selectReply}
                />

                <Modal
                    title={''}
                    visible={this.state.showViewImage}
                    onCancel={() => this.setState({ showViewImage: false })}
                    className={"modal-image"}
                    zIndex={1062}
                    footer={[
                        <Button key="back" onClick={() => this.setState({ showViewImage: false })}>
                            Đóng
                        </Button>
                    ]}
                >
                    <div className="box-image">
                        <img src={this.state.linkViewImage} onError={(e) => {
                            e.target.src = require('../../../img/no_images.png')
                        }} />
                    </div>
                </Modal>

                <Modal
                    title={'Chia sẻ bài viết'}
                    visible={this.state.formPostLink}
                    footer={[
                        <Button key="back" onClick={this.cancelModalShareLink}>
                            Đóng
                        </Button>,
                        <Button key="submit" type="primary" onClick={this.addLink}>
                            Thêm mới
                        </Button>,
                    ]}
                    onCancel={this.cancelModalShareLink}
                    onOk={this.addLink}
                    className="modal-h-antd"
                >
                    <Form
                        name="basic"
                        ref={(evt) => this.formShareLink = evt}
                        onFinish={this.addLink}
                    >
                        <Form.Item name="link" rules={[{ required: true, message: 'Liên kết không được để trống' }]}>
                            <Input placeholder={'Nhập liên kết'}
                                ref={(evt) => this.refInputLinkInsta = evt}
                            />
                        </Form.Item>
                    </Form>
                </Modal>

                {
                    this.props.isMobile && (
                        <React.Fragment>
                            <div
                                className={cx('chat-mobile-action-mask', this.state.showMobileActionSheet ? 'show' : '')}
                                onClick={() => this.toggleMobileActionSheet(false)}
                            ></div>
                            <div className={cx('chat-mobile-action-sheet-panel', this.state.showMobileActionSheet ? 'show' : '')}>
                                <div className="sheet-handle"></div>
                                <div className="sheet-header">
                                    <div>
                                        <div className="sheet-title">Tác vụ hội thoại</div>
                                        <div className="sheet-subtitle">Chọn thao tác cần dùng cho khách hàng này.</div>
                                    </div>
                                    <button type="button" className="sheet-close" onClick={() => this.toggleMobileActionSheet(false)}>
                                        Đóng
                                    </button>
                                </div>
                                <div className="sheet-actions">
                                    {
                                        mobileHeaderActions.map((action) => (
                                            <button
                                                type="button"
                                                key={action.key}
                                                className={cx('sheet-action-item', action.dangerous ? 'dangerous' : '', action.active ? 'active' : '')}
                                                onClick={action.onClick}
                                            >
                                                <span className="sheet-action-icon">{action.icon}</span>
                                                <span className="sheet-action-content">
                                                    <span className="sheet-action-label">{action.label}</span>
                                                    <span className="sheet-action-description">{action.description}</span>
                                                </span>
                                                {action.suffix ? <span className="sheet-action-suffix">{action.suffix}</span> : <i className="far fa-angle-right sheet-action-arrow"></i>}
                                            </button>
                                        ))
                                    }
                                </div>
                            </div>
                        </React.Fragment>
                    )
                }

                {/* form send sms brandname */}

                {
                    this.props.contactInfoSelected && <WidgetFormSmsBrandName
                        {...this.props}
                        visible={this.state.visibleSms}
                        hide={() => this.setState({ visibleSms: false })}
                        contact={this.props.contactInfoSelected}
                    />
                }

                <LoadSpinner show={this.props.loading} />

                {
                    this.props.contactInfoSelected ?
                        <div id="topic-caption-panel" className="caption-panel" style={this.props.statusBarHeight ? { paddingTop: `${this.props.statusBarHeight}px` } : {}}>
                            <Link to="/chat" id="hide-message-view" className="btn-arrow-back"><i className="fal fa-arrow-left"></i></Link>
                            {
                                <a href="#" className="avatar-box">
                                    {avatar}
                                    {/* <span className="online"></span> */}
                                </a>
                            }
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', marginLeft: '12px', minWidth: 0 }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ fontSize: '15px', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {topTitle}
                                    </div>
                                    {this.props.contactInfoSelected?.ai_info && (
                                        <span style={{ 
                                            marginLeft: '8px', 
                                            padding: '2px 8px', 
                                            borderRadius: '10px', 
                                            fontSize: '10px', 
                                            background: stageMap[this.props.contactInfoSelected.ai_info.current_stage]?.color || '#8c8c8c',
                                            color: '#fff',
                                            fontWeight: 'bold'
                                        }}>
                                            {stageMap[this.props.contactInfoSelected.ai_info.current_stage]?.name || this.props.contactInfoSelected.ai_info.current_stage}
                                        </span>
                                    )}
                                </div>
                                {this.props.contactInfoSelected?.ai_info?.extracted_info && (
                                    <div style={{ display: 'flex', marginTop: '2px' }}>
                                        {this.renderExtractedInfo(this.props.contactInfoSelected.ai_info.extracted_info)}
                                    </div>
                                )}
                            </div>
                            <div id="topic-users"> </div>
                            <div className="d-flex align-items-center header-actions">
                                {
                                    !this.props.isMobile && <ul id="chat-menu-bar-tool" className="chat-menu-bar" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    {/* AI TOGGLE */}
                                    <li>
                                        <Tooltip title={!this.state.ai_available
                                            ? (this.state.ai_status_loading ? 'Đang kiểm tra cấu hình AI' : (this.state.ai_warning || 'AI chung của công ty chưa được bật'))
                                            : (this.state.ai_mode ? "Tắt AI" : "Bật AI")}>
                                            <div className="action-button ai-pill" style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                background: !this.state.ai_available ? '#fff7e6' : (this.state.ai_mode ? '#e6f7ff' : '#f5f5f5'),
                                                padding: '2px 8px', 
                                                borderRadius: '20px',
                                                cursor: 'pointer',
                                                height: '32px',
                                                border: `1px solid ${!this.state.ai_available ? '#ffd591' : (this.state.ai_mode ? '#91d5ff' : '#d9d9d9')}`,
                                                transition: 'all 0.3s'
                                            }} onClick={!this.state.ai_available
                                                ? this.showAIConfigurationWarning
                                                : () => this.toggleAIMode(!this.state.ai_mode)}>
                                                {!this.state.ai_available && <ExclamationCircleOutlined style={{ color: '#fa8c16', marginRight: '5px' }} />}
                                                <span style={{ color: !this.state.ai_available ? '#d46b08' : (this.state.ai_mode ? '#1890ff' : '#8c8c8c'), fontSize: '11px', marginRight: '6px', fontWeight: 'bold' }}>AI</span>
                                                <AntSwitch 
                                                    size="small" 
                                                    checked={this.state.ai_mode} 
                                                    disabled={!this.state.ai_available || this.state.ai_status_loading}
                                                    style={{ pointerEvents: 'none' }}
                                                />
                                            </div>
                                        </Tooltip>
                                    </li>

                                    {/* RESET AI BUTTON */}
                                    <li>
                                        <Tooltip title="Reset AI">
                                            <div className="action-button-circle" style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                justifyContent: 'center',
                                                background: '#ff4d4f', 
                                                width: '32px',
                                                height: '32px', 
                                                borderRadius: '50%',
                                                cursor: 'pointer',
                                                color: '#fff',
                                                border: '1px solid #f5222d',
                                                boxShadow: '0 2px 0 rgba(255, 77, 79, 0.2)',
                                                transition: 'all 0.2s'
                                            }} onClick={this.clearAIHistory}>
                                                <ReloadOutlined style={{ fontSize: '14px', fontWeight: 'bold' }} />
                                            </div>
                                        </Tooltip>
                                    </li>

                                    <div style={{ height: '20px', width: '1px', background: '#e8e8e8', margin: '0 5px' }}></div>
                                    {
                                        (this.props.UserLogin.role_action.indexOf('full_role') > -1 || this.props.UserLogin.role_action.indexOf('history_contact_sale') > -1) ?
                                            <li>
                                                <Tooltip placement="bottom" title={'Lịch sử chăm sóc khách hàng'}>
                                                    <div className="action-button-circle secondary" style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center',
                                                        background: '#eeeeee', 
                                                        width: '32px',
                                                        height: '32px', 
                                                        borderRadius: '50%',
                                                        cursor: 'pointer',
                                                        color: '#262626',
                                                        border: '1px solid #d9d9d9',
                                                        transition: 'all 0.2s'
                                                    }} onClick={(e) => {
                                                        e.preventDefault();
                                                        this.props.handleHistoryContactSale();
                                                    }}>
                                                        <i className="far fa-history" style={{ fontSize: '14px' }}></i>
                                                    </div>
                                                </Tooltip>
                                            </li> : null
                                    }
                                    {/* Tạm ẩn Kiểm tra bệnh án theo yêu cầu */}
                                    {/* 
                                    {
                                        this.props.isSalesContact ?
                                            <li>
                                                <Tooltip placement="bottom" title={'Kiểm tra bệnh án'}>
                                                    <div className="action-button-circle secondary" style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center',
                                                        background: '#eeeeee', 
                                                        width: '32px',
                                                        height: '32px', 
                                                        borderRadius: '50%',
                                                        cursor: 'pointer',
                                                        color: '#262626',
                                                        border: '1px solid #d9d9d9',
                                                        transition: 'all 0.2s'
                                                    }} onClick={(e) => {
                                                        e.preventDefault();
                                                        let phone = this.props.contactInfoSelected.from.phone;
                                                        if (!phone) phone = this.props.contactInfoSelected.phone_list[Math.floor(Math.random() * this.props.contactInfoSelected.phone_list.length)];
                                                        this.props.getHisBooking(phone);
                                                    }}>
                                                        <i className="fa fa-id-badge" style={{ fontSize: '14px' }}></i>
                                                    </div>
                                                </Tooltip>
                                            </li> : null
                                    }
                                    */}
                                    {
                                        this.props.contactInfoSelected.sale && this.props.contactInfoSelected.sale.status == 1 || (this.props.UserLogin.role_company.indexOf('sale') == -1 && this.props.contactInfoSelected.sales && this.props.contactInfoSelected.sales.length == 0) ?
                                            <li>
                                                <Tooltip placement="bottom" title={'Chuyển nhân viên chăm sóc'} mouseEnterDelay={this.props.mouseEnterDelayTooltip} mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}>
                                                    <div className="action-button-circle secondary" style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center',
                                                        background: '#f5f5f5', 
                                                        width: '32px',
                                                        height: '32px', 
                                                        borderRadius: '50%',
                                                        cursor: 'pointer',
                                                        color: '#595959',
                                                        border: '1px solid #d9d9d9',
                                                        transition: 'all 0.2s'
                                                    }} onClick={(e) => {
                                                        e.preventDefault();
                                                        if (!(this.props.contactInfoSelected && this.props.contactInfoSelected.sale && this.props.contactInfoSelected.sale.status == 3)) {
                                                            this.props.handleModalChangeSales();
                                                        }
                                                    }}>
                                                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 16.555 16.555" height="14px" width="14px">
                                                            <g><g>
                                                                <path d="M6.409,7.421c0.034,0.207,0.114,0.337,0.193,0.42C6.789,9.084,7.83,10.24,8.781,10.24    c1.11,0,2.12-1.25,2.314-2.397c0.08-0.082,0.16-0.213,0.195-0.422c0.063-0.233,0.146-0.639,0.002-0.828    c-0.007-0.01-0.017-0.019-0.022-0.028c0.133-0.489,0.303-1.501-0.303-2.19C10.912,4.306,10.572,3.9,9.846,3.686L9.5,3.566    C8.928,3.39,8.568,3.35,8.553,3.349c-0.026-0.002-0.053,0-0.078,0.006C8.454,3.361,8.387,3.379,8.334,3.372    c-0.137-0.02-0.342,0.05-0.378,0.064C7.909,3.455,6.802,3.898,6.466,4.93C6.435,5.013,6.3,5.452,6.479,6.527    c-0.027,0.018-0.05,0.041-0.071,0.067C6.264,6.783,6.345,7.188,6.409,7.421z" />
                                                                <path d="M12.33,10.637c0,0-0.045-0.015-0.114-0.037c-0.478-0.224-0.929-0.367-0.929-0.367    c-0.098-0.033-0.182-0.067-0.26-0.103c-0.322-0.159-0.592-0.34-0.648-0.51c0,0,0.188,1.81-1.395,1.851l-0.219-0.01    c-1.433-0.127-1.528-1.845-1.528-1.845c-0.15,0.471-1.952,1.019-1.952,1.019c-0.536,0.204-0.762,0.514-0.762,0.514    c-0.792,1.176-0.885,3.789-0.885,3.789c0.01,0.598,0.268,0.66,0.268,0.66c1.821,0.812,4.679,0.955,4.679,0.955    c0.154,0.004,0.298-0.004,0.441-0.013l0.003,0.015c0,0,2.858-0.145,4.679-0.957c0,0,0.258-0.063,0.269-0.658    c0,0-0.094-2.614-0.886-3.789C13.092,11.148,12.865,10.841,12.33,10.637z" />
                                                                <path d="M10.316,9.698c0.021-0.026,0.041-0.052,0.063-0.078c-0.004-0.017-0.005-0.026-0.005-0.026    C10.356,9.632,10.336,9.661,10.316,9.698z" />
                                                                <path d="M7.246,9.614L7.241,9.595L7.237,9.616c0.001-0.004,0.004-0.009,0.006-0.011    C7.243,9.605,7.244,9.607,7.246,9.614z" />
                                                                <path d="M8.732,0C4.436,0,0.94,3.496,0.94,7.792c0,0.849,0.148,1.692,0.417,2.492l-0.702-0.157    c-0.277-0.065-0.55,0.111-0.612,0.388c-0.062,0.275,0.111,0.549,0.388,0.611l2.332,0.523c0.038,0.008,0.075,0.012,0.112,0.012    c0.234,0,0.446-0.162,0.5-0.399l0.499-2.221c0.062-0.276-0.112-0.55-0.387-0.612C3.208,8.368,2.937,8.54,2.875,8.816L2.706,9.571    C2.537,8.998,2.441,8.404,2.441,7.792c0-3.47,2.823-6.292,6.292-6.292s6.292,2.823,6.292,6.292c0,1.047-0.262,2.082-0.758,2.992    l1.318,0.717c0.614-1.131,0.939-2.412,0.939-3.709C16.524,3.496,13.028,0,8.732,0z" />
                                                            </g></g>
                                                        </svg>
                                                    </div>
                                                </Tooltip>
                                            </li> : null
                                    }
                                    {
                                        this.props.contactInfoSelected.type == 'comment' ?
                                            <li>
                                                <Tooltip placement="bottom" title={'Tất cả hội thoại của bài viết này'} mouseEnterDelay={this.props.mouseEnterDelayTooltip} mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}>
                                                    <div className={cx('action-button-circle secondary', this.props.search_keyword === `post:${this.props.contactInfoSelected.media_id}` ? 'active' : '')} 
                                                        style={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            justifyContent: 'center',
                                                            background: this.props.search_keyword === `post:${this.props.contactInfoSelected.media_id}` ? '#bae7ff' : '#eeeeee', 
                                                            width: '32px',
                                                            height: '32px', 
                                                            borderRadius: '50%',
                                                            cursor: 'pointer',
                                                            color: this.props.search_keyword === `post:${this.props.contactInfoSelected.media_id}` ? '#0050b3' : '#262626',
                                                            border: `1px solid ${this.props.search_keyword === `post:${this.props.contactInfoSelected.media_id}` ? '#69c0ff' : '#d9d9d9'}`,
                                                            transition: 'all 0.2s'
                                                        }} onClick={(e) => {
                                                            e.preventDefault();
                                                            this.props.handleSearchKeyword(`post:${this.props.contactInfoSelected.media_id}`);
                                                        }}>
                                                        <svg fill="currentColor" enableBackground="new 0 0 496 496" height="14px" viewBox="0 0 496 496" width="14px" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="m344 59.496h-296c-26.47 0-48 21.53-48 48v172c0 26.47 21.53 48 48 48h43.08l.92 43.34c.281 13.002 15.209 20.285 25.63 12.44 78.785-59.398 67.621-50.982 73.99-55.78h152.38c26.47 0 48-21.53 48-48v-172c0-26.47-21.53-48-48-48zm-93 191h-110c-8.84 0-16-7.16-16-16s7.16-16 16-16h110c8.84 0 16 7.16 16 16s-7.16 16-16 16zm29-70h-168c-8.84 0-16-7.16-16-16s7.16-16 16-16h168c8.84 0 16 7.16 16 16s-7.16 16-16 16zm216 27v132c0 26.51-21.49 48-48 48h-43.15l-.85 33.41c-.227 8.69-7.363 15.59-16 15.59-6.322 0-1.703 1.809-82.86-49h-70.14c-12.236 0-23.414-4.602-31.897-12.165-10.987-9.796-4.097-27.974 10.623-27.974h145.57c31.041 0 56.204-25.163 56.204-56.204v-115.657c0-8.837 7.163-16 16-16h16.5c26.51 0 48 21.49 48 48z"></path>
                                                        </svg>
                                                    </div>
                                                </Tooltip>
                                            </li> : null
                                    }
                                    <li>
                                        <Tooltip placement="bottom" title={'Tất cả hội thoại của người dùng này'} mouseEnterDelay={this.props.mouseEnterDelayTooltip} mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}>
                                            <div className={cx('action-button-circle secondary', this.props.search_keyword === `uid:${this.props.contactInfoSelected.user_id || this.props.contactInfoSelected.userid}` ? 'active' : '')} 
                                                style={{ 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    justifyContent: 'center',
                                                    background: this.props.search_keyword === `uid:${this.props.contactInfoSelected.user_id || this.props.contactInfoSelected.userid}` ? '#bae7ff' : '#eeeeee', 
                                                    width: '32px',
                                                    height: '32px', 
                                                    borderRadius: '50%',
                                                    cursor: 'pointer',
                                                    color: this.props.search_keyword === `uid:${this.props.contactInfoSelected.user_id || this.props.contactInfoSelected.userid}` ? '#0050b3' : '#262626',
                                                    border: `1px solid ${this.props.search_keyword === `uid:${this.props.contactInfoSelected.user_id || this.props.contactInfoSelected.userid}` ? '#69c0ff' : '#d9d9d9'}`,
                                                    transition: 'all 0.2s'
                                                }} onClick={(e) => {
                                                    e.preventDefault();
                                                    this.props.handleSearchKeyword(`uid:${this.props.contactInfoSelected.user_id || this.props.contactInfoSelected.userid}`);
                                                }}>
                                                <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="16px" width="16px" viewBox="0 0 40 40" className="customer-conversations" style={{ verticalAlign: "middle" }}>
                                                    <g>
                                                        <path d="m19.8 22.5c2.3 0 4.2-1.6 4.8-3.7h8.9v11.2h-27.5v-11.2h8.9c0.6 2.1 2.5 3.7 4.9 3.7z m-8.8-5h-5l5-7.5v6.3h1.3v-6.3h15v6.3h1.2v-6.3l5 7.5h-10c0 2-1.7 3.8-3.7 3.8s-3.8-1.8-3.8-3.8h-5z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                        </Tooltip>
                                    </li>
                                    {
                                        (this.props.contactInfoSelected.type == "direct" || this.props.contactInfoSelected.type == "comment") && this.props.isSalesContact && link != "#" ?
                                            <li>
                                                <Tooltip placement="bottom" title={`Xem trên 'Facebook'`} mouseEnterDelay={this.props.mouseEnterDelayTooltip} mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}>
                                                    <div className="action-button-circle secondary" 
                                                        style={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            justifyContent: 'center',
                                                            background: 'dodgerblue', 
                                                            width: '32px',
                                                            height: '32px', 
                                                            borderRadius: '50%',
                                                            cursor: 'pointer',
                                                            color: '#fff',
                                                            border: '1px solid #1890ff',
                                                            boxShadow: '0 2px 0 rgba(0,0,0,0.045)',
                                                            transition: 'all 0.2s'
                                                        }} onClick={() => window.open(link, '_blank')}>
                                                        <svg fill="currentColor" preserveAspectRatio="xMidYMid meet" height="16px" width="16px" viewBox="0 0 40 40" style={{ verticalAlign: "middle", transform: "rotate(45deg)" }}>
                                                            <g>
                                                                <path d="m21.5 33.4h-3.3v-20.4l-9.4 9.3-2.3-2.3 13.4-13.4 13.3 13.4-2.3 2.4-9.4-9.4v20.4z"></path>
                                                            </g>
                                                        </svg>
                                                    </div>
                                                </Tooltip>
                                            </li>
                                            : null
                                    }
                                    {
                                        (this.props.contactInfoSelected.type == "callcenter" || this.props.contactInfoSelected.type == "www")
                                            && (this.props.isSalesContact || this.props.contactInfoSelected.num_care == 0) ?
                                            <li>
                                                <Tooltip placement="bottom" title={'Call'} mouseEnterDelay={this.props.mouseEnterDelayTooltip} mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}>
                                                    <div className="action-button-circle secondary" style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center',
                                                        background: '#eeeeee', 
                                                        width: '32px',
                                                        height: '32px', 
                                                        borderRadius: '50%',
                                                        cursor: 'pointer',
                                                        color: '#262626',
                                                        border: '1px solid #d9d9d9',
                                                        transition: 'all 0.2s'
                                                    }} onClick={(e) => {
                                                        e.preventDefault();
                                                        this.props.handleCallCustomer({
                                                            cus_phone: this.props.contactInfoSelected.num_care == 0 ? null : this.props.contactInfoSelected.user_id,
                                                            contact_id: this.props.contactInfoSelected.contact_id
                                                        });
                                                    }}>
                                                        <i className="far fa-phone" style={{ fontSize: '14px' }}></i>
                                                    </div>
                                                </Tooltip>
                                            </li> : null
                                    }
                                    {
                                        this.props.contactInfoSelected.type == 'comment' ?
                                            <li>
                                                <Tooltip title={this.state.hiddenComment ? 'Bật ẩn bình luận' : 'Tắt ẩn bình luận'} >
                                                    <div className="action-button-circle secondary" style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center',
                                                        background: '#eeeeee', 
                                                        width: '32px',
                                                        height: '32px', 
                                                        borderRadius: '50%',
                                                        cursor: 'pointer',
                                                        color: this.state.hiddenComment ? '#1890ff' : '#262626',
                                                        border: '1px solid #d9d9d9',
                                                        transition: 'all 0.2s'
                                                    }} onClick={this.hiddenComment}>
                                                        {
                                                            this.state.hiddenComment ? <i className="fa fa-eye-slash" style={{ fontSize: '14px' }}></i> : <i className="fa fa-eye" style={{ fontSize: '14px' }}></i>
                                                        }
                                                    </div>
                                                </Tooltip>
                                            </li> : null
                                    }
                                    {/* Tạm ẩn SMS theo yêu cầu */}
                                    {/* 
                                    {
                                        this.props.contactInfoSelected.phone_list_all.length > 0 ?
                                            <li>
                                                <Tooltip placement="bottom" title={'Sms'} mouseEnterDelay={this.props.mouseEnterDelayTooltip} mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}>
                                                    <div className="action-button-circle secondary" style={{ 
                                                        display: 'flex', 
                                                        alignItems: 'center', 
                                                        justifyContent: 'center',
                                                        background: '#eeeeee', 
                                                        width: '32px',
                                                        height: '32px', 
                                                        borderRadius: '50%',
                                                        cursor: 'pointer',
                                                        color: '#262626',
                                                        border: '1px solid #d9d9d9',
                                                        transition: 'all 0.2s'
                                                    }} onClick={(e) => {
                                                        e.preventDefault();
                                                        this.setState({ visibleSms: true })
                                                    }} >
                                                        <i className="fa fa-envelope" style={{ fontSize: '14px' }}></i>
                                                    </div>
                                                </Tooltip>
                                            </li> : null
                                    }
                                    */}
                                    </ul>
                                }
                                {
                                    this.props.isMobile && <ul className="chat-menu-bar pl-0 chat-menu-bar-mobile" style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '8px' }}>
                                        <li className="see-more">
                                            <button
                                                type="button"
                                                className="chat-mobile-header-button chat-mobile-action-trigger"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    this.toggleMobileActionSheet(true);
                                                }}
                                            >
                                                <BsThreeDotsVertical size={18} />
                                            </button>
                                        </li>
                                    </ul>
                                }
                            </div>
                        </div> : <div id="topic-caption-panel" className="caption-panel" style={this.props.statusBarHeight ? { paddingTop: `${this.props.statusBarHeight}px` } : {}}>
                            <Link to="/chat" id="hide-message-view" className="btn-arrow-back"><i className="fal fa-arrow-left"></i></Link>
                            <div id="topic-users"></div>
                            <ul className="chat-menu-bar pl-0">
                                <li className="see-more">
                                    <a href="#" >
                                        <i className="far fa-ellipsis-v" style={{ fontSize: "20px" }}></i>
                                    </a>
                                </li>
                                <li className="see-more">
                                    <a href="#" >
                                        <i className="far fa-info" style={{ fontSize: "20px" }}></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                }
                <div id="messages-container">
                    <WidgetConfirmSales visible={this.props.contactInfoSelected && this.props.contactInfoSelected.type != "callcenter" && this.props.contactInfoSelected.sale && this.props.contactInfoSelected.sale.status == 0}
                        confirmSales={this.props.confirmSales}
                        loading={this.props.loadingConfirmSales}
                        contactInfoSelected={this.props.contactInfoSelected}
                    />
                    <div id="messages-panel" onScroll={(e) => {
                        if (this.state.focusSendMessage) document.querySelectorAll("textarea").forEach((item) => item.blur());

                        this.props.handleScrollBoxMessage(e);
                    }} ref={(evt) => this.props.setRefMessage(evt)}>
                        {this.props.contactInfoSelected ? <SourceContact contact={this.props.contactInfoSelected} /> : null}
                        <ul id="scroller" className="chat-box group">
                            {
                                this.props.contactInfoSelected && this.props.listMessage.map((item, i) => {
                                    let html = [];
                                    if (item.item_type != "handle_sale") {
                                        html.push(<MessageViewItem
                                            Message={item}
                                            key={item.item_id}
                                            contactInfoSelected={this.props.contactInfoSelected}
                                            channelSelected={this.props.channelSelected}
                                            showViewImage={this.showViewImage}
                                            left={(this.props.contactInfoSelected.type != "callcenter" && this.props.contactInfoSelected.user_owner_id != item.user_id) || (this.props.contactInfoSelected.type == "callcenter" && item.call_type == 0)}
                                            handleCommentReply={this.handleCommentReply}
                                            handleDetailUser={this.props.handleDetailUser}
                                            hiddenComment={this.props.hiddenComment}
                                            handleShowFormDirectNew={this.handleShowFormDirectNew}
                                            type={this.props.contactInfoSelected.type}
                                            replaySendMessage={this.replaySendMessage}
                                            isSalesContact={this.props.isSalesContact}
                                            handleCallCustomer={this.props.handleCallCustomer}
                                        />)
                                        if (item.reply) {
                                            // item.reply = item.reply.sort((a,b) => b.timestamp - a.timestamp);
                                            item.reply.forEach((item) => {
                                                html.push(<MessageViewItem
                                                    Message={item}
                                                    key={item.item_id}
                                                    contactInfoSelected={this.props.contactInfoSelected}
                                                    channelSelected={this.props.channelSelected}
                                                    showViewImage={this.showViewImage}
                                                    left={this.props.contactInfoSelected.user_owner_id != item.user_id}
                                                    left_reply={this.props.contactInfoSelected.user_owner_id != item.user_id}
                                                    handleCommentReply={this.handleCommentReply}
                                                    handleDetailUser={this.props.handleDetailUser}
                                                    hiddenComment={this.props.hiddenComment}
                                                    handleShowFormDirectNew={this.handleShowFormDirectNew}
                                                    type={this.props.contactInfoSelected.type}
                                                    replaySendMessage={this.replaySendMessage}
                                                    isSalesContact={this.props.isSalesContact}
                                                    handleCallCustomer={this.props.handleCallCustomer}
                                                    getListMessage={this.props.getListMessage}
                                                />)
                                            })
                                        }
                                    } else {
                                        html.push(<MessageViewItem
                                            Message={item}
                                            key={item.item_id}
                                            contactInfoSelected={this.props.contactInfoSelected}
                                            channelSelected={this.props.channelSelected}
                                            showViewImage={this.showViewImage}
                                            center={true}
                                            UserLogin={this.props.UserLogin}
                                            handleDetailUser={this.props.handleDetailUser}
                                            hiddenComment={this.props.hiddenComment}
                                            handleShowFormDirectNew={this.handleShowFormDirectNew}
                                            type={this.props.contactInfoSelected.type}
                                            replaySendMessage={this.replaySendMessage}
                                            isSalesContact={this.props.isSalesContact}
                                            handleCallCustomer={this.props.handleCallCustomer}
                                        />)
                                    }
                                    return html
                                })
                            }
                        </ul>
                    </div>
                </div>
                <form encType="multipart/form-data" id="send-message-panel" className={`${!this.props.isSalesContact ? "disable-sale" : ""}`}>
                    <FormReplyFast {...this.props}
                        visible={this.state.showReplyFast}
                        hide={() => this.setState({ showReplyFast: false })}
                        selectReply={this.selectReply}
                        typeReplySample={"quick_reply"}
                    />

                    {/* {
                        tag_favourites.length > 0 && this.props.contactInfoSelected ?
                            <div className="list-tags">{tag_favourites.map((item) => {
                                return <ItemTag key={item.tag_id}
                                    active={this.props.contactInfoSelected.tags && this.props.contactInfoSelected.tags.find((tag) => tag.tag_id == item.tag_id) ? true : false}
                                    tag={item}
                                    contactInfoSelected={this.props.contactInfoSelected}
                                    handleUpdateTag={this.props.handleUpdateTag}
                                />
                            })}</div> : null
                    } */}
                    {
                        this.props.settingSystem ? <WidgetListTag tags={this.props.settingSystem.tags} contactInfoSelected={this.props.contactInfoSelected} handleUpdateTag={this.props.handleUpdateTag} /> : null
                    }
                    <div>
                        {
                            this.state.comment_reply && this.props.contactInfoSelected.type == 'comment' ?
                                <div className="alert-reply">
                                    <i className="material-icons reply">reply</i>
                                    Trả lời: <span className="title">{this.state.comment_reply.content}</span>
                                </div> : null
                        }
                        {
                            htmlPreviewAttachment.length > 0 ?
                                <div className="row-preview-image">
                                    {htmlPreviewAttachment}
                                </div> : null
                        }
                        <div className={`form-add-mes-m ${this.props.contactInfoSelected && this.props.contactInfoSelected.sale && this.props.contactInfoSelected.sale.status == 3 || (this.props.contactInfoSelected && (this.props.contactInfoSelected.type == "callcenter" || this.props.contactInfoSelected.type == "www")) ? 'form-send-mes-disabled' : ''}`}>

                            {
                                this.props.contactInfoSelected && this.props.channelSelected.acc_type == 1 && this.props.contactInfoSelected.type == 'direct' ?
                                    <Tooltip placement="top" title={'Chia sẻ bài viết'} mouseEnterDelay={this.props.mouseEnterDelayTooltip} mouseLeaveDelay={this.props.mouseLeaveDelayTooltip}>
                                        <a href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.setState({
                                                    formPostLink: true
                                                }, () => {
                                                    if (this.refInputLinkInsta) {
                                                        this.refInputLinkInsta.focus()
                                                    }
                                                })
                                            }}
                                        >
                                            <i className="material-icons secondary" style={{ fontSize: "24px" }}>attach_file</i>
                                        </a>
                                    </Tooltip> : null
                            }

                            {
                                this.props.isMobile ?
                                    <ButtonShowEmoji
                                        visible={this.state.visibleEmoji}
                                        onVisibleChange={(e) => {
                                            this.setState({ visibleEmoji: e })
                                        }}
                                        onEmojiClick={(e, value) => {
                                            this.setState({
                                                message: this.state.message + value.emoji
                                            })
                                        }}
                                    />
                                    : null
                            }

                        <div className="modern-input-row">
                            <div className={`modern-input-container ${this.props.contactInfoSelected && this.props.contactInfoSelected.sale && this.props.contactInfoSelected.sale.status == 3 || (this.props.contactInfoSelected && (this.props.contactInfoSelected.type == "callcenter" || this.props.contactInfoSelected.type == "www")) ? 'form-send-mes-disabled' : ''}`}>
                                
                                {this.state.countDownDirectNew ? (
                                    <div className="modern-badge-countdown">
                                        <Tooltip placement="top" title={`Nhắn tin cho người lạ sau ${this.state.countDownDirectNew}s`}>
                                            <span>{this.state.countDownDirectNew}s</span>
                                        </Tooltip>
                                    </div>
                                ) : null}

                                <textarea ref={(evt) => this.textAreaRef = evt}
                                    onChange={(e) => {
                                        e.target.style.height = "24px";
                                        e.target.style.height = Math.min(e.target.scrollHeight, 200) + "px";
                                        this.setState({
                                            message: e.target.value
                                        })
                                    }}
                                    id="sendMessage" name="message" placeholder="Type your message..."
                                    onKeyDown={(evt) => this.handleKeyUp(evt)}
                                    value={this.state.message}
                                    onFocus={(e) => {
                                        this.focusSendMessage = true;
                                        this.setState({ focusSendMessage: true });
                                    }}
                                    onBlur={(e) => {
                                        setTimeout(() => this.setState({ focusSendMessage: false }), 200);
                                        this.focusSendMessage = false;
                                    }}
                                />

                                <div className="modern-actions-container">
                                    <div id="message-toolbar-bottom" className={cx("d-flex align-items-center", this.props.isMobile && !this.state.focusSendMessage ? "d-none" : "d-flex")}>
                                        
                                        {/* Attachment for Instagram Direct */}
                                        {this.props.contactInfoSelected && this.props.channelSelected.acc_type == 1 && this.props.contactInfoSelected.type == 'direct' && (
                                            <Tooltip placement="top" title={'Chia sẻ bài viết'}>
                                                <a href="#" className="btn-manage-tool" onClick={(e) => {
                                                    e.preventDefault();
                                                    this.setState({ formPostLink: true }, () => {
                                                        if (this.refInputLinkInsta) this.refInputLinkInsta.focus()
                                                    })
                                                }}>
                                                    <MdOutlineAttachment size={20} />
                                                </a>
                                            </Tooltip>
                                        )}

                                        {/* Quick Reply (Old action restored) */}
                                        <Tooltip placement="top" title={'Tin trả lời lưu sẵn'}>
                                            <a href="#" className="btn-manage-tool" onClick={(e) => {
                                                e.preventDefault();
                                                if (this.props.settingSystem.quick_reply.length == 0) {
                                                    this.setState({ showReplyFast: true }, () => {
                                                        this.setState({ showEditQuickReply: true })
                                                    })
                                                } else {
                                                    this.setState({ showReplyFast: !this.state.showReplyFast }, () => {
                                                        if (!this.props.isMobile) this.textAreaRef.focus();
                                                    })
                                                }
                                            }}>
                                                <HiOutlineLightningBolt size={20} />
                                            </a>
                                        </Tooltip>

                                        {/* Send Product (Old action restored) */}
                                        <Tooltip placement="top" title={'Gửi sản phẩm'}>
                                            <a href="#" className="btn-manage-tool" onClick={(e) => {
                                                e.preventDefault();
                                                this.setState({ showReplyProduct: !this.state.showReplyProduct }, () => {
                                                    if (!this.props.isMobile) this.textAreaRef.focus();
                                                })
                                            }}>
                                                <HiOutlinePhotograph size={20} />
                                            </a>
                                        </Tooltip>

                                        <ButtonShowEmoji
                                            visible={this.state.visibleEmoji}
                                            onVisibleChange={(e) => {
                                                this.setState({ visibleEmoji: e })
                                            }}
                                            onEmojiClick={(e, value) => {
                                                this.setState({
                                                    message: this.state.message + value.emoji
                                                })
                                            }}
                                        />

                                        <Tooltip placement="top" title={'Voice message'}>
                                            <a href="#" className="btn-manage-tool">
                                                <HiMicrophone size={20} />
                                            </a>
                                        </Tooltip>

                                        {/* Main Attachment Upload */}
                                        {btnUpload && (
                                            <Tooltip placement="top" title={'Tệp đính kèm'}>
                                                <label className="btn-manage-tool" htmlFor="inputUploadImage">
                                                    <HiOutlinePaperClip size={20} />
                                                </label>
                                            </Tooltip>
                                        )}

                                        {/* Send with Tag (Old action restored) */}
                                        {!this.props.isMobile && this.props.contactInfoSelected?.type == "direct" && (
                                            <Tooltip placement="top" title={'Gửi tin nhắn đính kèm nhãn'}>
                                                <a href="#" className="btn-manage-tool" onClick={(evt) => this.handleSendTag(evt)}>
                                                    <HiOutlineTag size={20} />
                                                </a>
                                            </Tooltip>
                                        )}

                                        {/* Mobile expand menu */}
                                        {this.props.isMobile && !this.state.focusSendMessage && (
                                            <a href="#" className="btn-manage-tool" onClick={(e) => {
                                                e.preventDefault();
                                                const toolbar = document.querySelector('#message-toolbar-bottom');
                                                if (toolbar.classList.contains("d-none")) {
                                                    toolbar.classList.add("d-flex");
                                                    toolbar.classList.remove("d-none");
                                                } else {
                                                    toolbar.classList.remove("d-flex");
                                                    toolbar.classList.add("d-none");
                                                }
                                            }}>
                                                <BsThreeDotsVertical size={20} />
                                            </a>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <Tooltip placement="top" title={'Enter để gửi, shift + enter để xuống dòng'}>
                                <button
                                    type="button"
                                    onClick={(evt) => this.handleSend(evt)}
                                    className="btn-send-modern"
                                >
                                    <RiSendPlaneFill size={22} />
                                </button>
                            </Tooltip>
                        </div>
                        {inputUploadAttachment}
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}
